import dayjs from "dayjs"

const useTimeFormat = function (seconds) {
  return dayjs.duration(0, "s").add(seconds, "seconds").format("HH:mm:ss")
}

export default useTimeFormat
